import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Accordion } from 'semantic-ui-react';
import {
  PageHeaderText,
  ArtworkBannerNotice,
  ArtworkDetailsCard,
} from 'iovisit-museum-theme/components/Views';

import {
  PageMetadata,
  ViewBlocks,
  RelatedItems,
} from 'iovisit-theme/components/Views';

import { Icon } from 'iovisit-theme/components';

const messages = defineMessages({
  artwork_credits: {
    id: 'artwork_credits',
    defaultMessage: 'Credits',
  },
  related_items: {
    id: 'artwork_related_items',
    defaultMessage: 'Correlati in evidenza',
  },
  related_artwork: {
    id: 'related_artwork',
    defaultMessage: 'Altre opere simili',
  },
  artwork_related_room: {
    id: 'artwork_related_room',
    defaultMessage: 'Visita le altre sale del museo',
  },
  artwork_more_info_close: {
    id: 'artwork_more_info_close',
    defaultMessage: 'Espandi contenuto',
  },
  artwork_more_info_open: {
    id: 'artwork_more_info_open',
    defaultMessage: 'Riduci contenuto',
  },
});

const ArtworkView = ({ content, location }) => {
  const intl = useIntl();

  const [activeIndex, setactiveIndex] = useState(0);

  function handleClick(e, titleProps) {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setactiveIndex(newIndex);
  }

  return (
    <div id="page-artwork" className="ui container">
      <PageHeaderText content={content} showShareLinks={true} />
      <ArtworkBannerNotice content={content} />

      <Accordion
        defaultActiveIndex={0}
        className="collapse-blocks artwork-accordion"
      >
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={handleClick}
          className="artwork-accordion-title"
        >
          {activeIndex === 0 ? (
            <>
              <Icon prefix="fas" icon="sort-down" className="icon" />
              {intl.formatMessage(messages.artwork_more_info_open)}
            </>
          ) : (
            <>
              <Icon prefix="fas" icon="sort-up" className="icon" />
              {intl.formatMessage(messages.artwork_more_info_close)}
            </>
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <ArtworkDetailsCard content={content} />
          <ViewBlocks content={content} location={location} />
        </Accordion.Content>
      </Accordion>

      {/* Items correlati */}
      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={true}
        />
      )}

      {/* Opere correlate dall'esterno */}
      {content.related_artwork?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_artwork)}
          items={content.related_artwork}
          background={(content.relatedItems || []).length === 0}
        />
      )}

      {/* Altre sale correlate */}
      {content.related_room?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.artwork_related_room)}
          items={content.related_room}
          background={(content.related_artwork || []).length === 0}
        />
      )}

      <PageMetadata content={content} />
    </div>
  );
};

export default ArtworkView;
